const getters = {
  getResult: (state) => state.results,
  getReasonsBy: (state) => (id) => {
    return state.reasons[id];
  },
};

export default getters;
